/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AfterViewInit, Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { DateTimeService } from '../../shared/datetime/datetime.service';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { ToastService, ToastType } from '../../shared/toast/toast.service';
import { PresentationTestRunResult } from '../models/test-run-presentation';
import { TestToolService } from '../services/test-tool.service';
import { GenericModalService, ModalSettingsTemplate } from '../../shared/generic-modal/generic-modal.service';
import { TestToolRunTestCasesDialogComponent, TestToolRunTestCasesDialogResult } from '../test-tool-run-test-cases-dialog/test-tool-run-test-cases-dialog.component';
import { CurrentUserService } from '../../user/services';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxiColumnModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';

@Component({
    selector: 'app-test-tool-test-runs',
    templateUrl: './test-tool-test-runs.component.html',
    styleUrls: ['./test-tool-test-runs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxiColumnModule, DxiButtonModule, DxTemplateModule]
})
export class TestToolTestRunsComponent implements OnInit, AfterViewInit {
    private router = inject(Router);
    public dateTimeService = inject(DateTimeService);
    private loadingPanelService = inject(LoadingPanelService);
    private toastService = inject(ToastService);
    private testToolService = inject(TestToolService);
    private currentUserService = inject(CurrentUserService);
    private modalService = inject(GenericModalService);

    public testRuns: PresentationTestRunResult[];
    private caseIdsToRun: number[] = [];
    private allowRunning = false;

    ngOnInit(): void {
        this.allowRunning = this.currentUserService.hasPermission('TestTool_Action_TestCase_Run');
    }

    ngAfterViewInit(): void {
        void this.refresh();
    }

    async runTestCases(): Promise<void> {
        if(!this.allowRunning) return;

        const modalSettings = new ModalSettingsTemplate('lg', 'static');
        modalSettings.windowClass = 'hugeModal';
        const result: TestToolRunTestCasesDialogResult = await this.modalService.openComponent(TestToolRunTestCasesDialogComponent, null, modalSettings);

        if (result && result.casesToRun.length > 0) {
            try {
                this.loadingPanelService.showLoadingPanelDirect('Starting test runs...');
                this.caseIdsToRun = result.casesToRun.map(e => e.Id);
                await this.testToolService.runTestCases(this.caseIdsToRun, result.comment ?? '');    
                this.toastService.showToast('Test runs started successfully', ToastType.success);
            }
            catch{
                this.toastService.showToast('Failed to start test runs...', ToastType.error);
            }
            finally {
                this.loadingPanelService.hideLoadingPanel();
            }
            await this.refresh();
        }
    }

    async refresh(): Promise<void> {
        try {
            this.loadingPanelService.showLoadingPanelDirect('Loading test runs...');
            this.testRuns = await this.testToolService.getTestRuns();
        }
        catch {
            this.toastService.showToast('Failed to load test runs...', ToastType.error);
        }
        finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    }

    onRowRemoving = (e: any) => {
        const presentationTestRunResult = e.data as PresentationTestRunResult;
        void this.testToolService.deleteTestRun(presentationTestRunResult.Id);
    };

    viewTestRunDocumentsRowEvent = (e: any) => {
        const presentationTestRunResult = e.row.data as PresentationTestRunResult;
        void this.viewTestRunDocumentsInternal(presentationTestRunResult.Id);
    };

    viewTestRunDocumentsDoubleClickEvent = (e: any) => {
        const presentationTestRunResult = e.data as PresentationTestRunResult;
        void this.viewTestRunDocumentsInternal(presentationTestRunResult.Id);
    };

    viewTestCaseRowEvent = (e: any) => {
        const presentationTestRunResult = e.row.data as PresentationTestRunResult;
        void this.router.navigate(['/test-tool/test-cases/test-case-interchanges', {testCaseId: presentationTestRunResult.TestCaseId, testCaseName: presentationTestRunResult.TestCaseName}]);
    }

    async viewTestRunDocumentsInternal(testRunId: number): Promise<boolean> {
        return await this.router.navigate(['/test-tool/test-runs/test-run-results', { testRunId: testRunId }]);
    }
}
